/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedFrequentlyAskedQuestions_buyPage = {
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly frequentlyAskedQuestions: ReadonlyArray<{
        readonly question: string | null;
        readonly answer: string | null;
    } | null> | null;
    readonly " $refType": "BuySharedFrequentlyAskedQuestions_buyPage";
};
export type BuySharedFrequentlyAskedQuestions_buyPage$data = BuySharedFrequentlyAskedQuestions_buyPage;
export type BuySharedFrequentlyAskedQuestions_buyPage$key = {
    readonly " $data"?: BuySharedFrequentlyAskedQuestions_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedFrequentlyAskedQuestions_buyPage">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedFrequentlyAskedQuestions_buyPage",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "meta",
      "storageKey": null,
      "args": null,
      "concreteType": "MetaData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "header",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "frequentlyAskedQuestions",
      "storageKey": null,
      "args": null,
      "concreteType": "BuyPageFrequentlyAskedQuestionType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "question",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "answer",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '556b7a2516a6c7705c3617e501ad9601';
export default node;
